import { trimEnd } from "lodash-es";

export function getBaseUrl(): string {
  return trimEnd(
    import.meta.env.VITE_BASE_URL || "https://console.pomerium.app",
    "/",
  );
}

// Examples:
// createURL(':22') -> URL object for 'http://localhost:22'
// createURL(':8080') -> URL object for 'http://localhost:8080'
// createURL('https://example.com') -> URL object for 'https://example.com'
// createURL('example.com:3000') -> URL object for 'http://example.com:3000'
export function createURL(
  urlString: string,
  defaultProtocol = "http",
  defaultHostname = "localhost",
) {
  if (!urlString) {
    throw new Error("URL string is required");
  }

  // If the string starts with just a colon and port number (e.g., ":22")
  if (urlString.match(/^:\d+$/)) {
    return new URL(`${defaultProtocol}://${defaultHostname}${urlString}`);
  }

  // If it's already a valid URL format, use it directly
  try {
    return new URL(urlString);
  } catch (error) {
    // If URL construction fails, try adding default protocol
    if (!urlString.includes("://")) {
      try {
        return new URL(`${defaultProtocol}://${urlString}`);
      } catch {
        throw new Error(`Unable to create valid URL from: ${urlString}`);
      }
    }
    throw error;
  }
}
